import http from "../http-rda";

class DataService {
  getAll(params) {
    return http.get("/teacher/notifications", { params });
  }

  getCounts() {
    return http.get("/teacher/notifications/counts");
  }

  markRead(id) {
    return http.patch(`/teacher/notifications/${id}/read`);
  }

  markResolved(id) {
    return http.patch(`/teacher/notifications/${id}/resolve`);
  }
}

export default new DataService();
